/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export class BaseEnum {
  // Class components
  constructor(value) {
    this.value = value;
  }

  toString() {
    return `${this.value}`;
  }
}
